var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"playlist-annotation",staticClass:"annotation-bar"},_vm._l((_vm.annotations),function(annotation,index){return _c('span',{key:("annotation-" + index),staticClass:"annotation-mark",style:({
      left: _vm.getAnnotationPosition(annotation) + 'px'
    }),on:{"click":function($event){return _vm.$emit('select-annotation', annotation)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }